import type { PropertyStatus } from '../../api/properties'

// =============================================================================
// Status Configuration
// =============================================================================

export const STATUS_CONFIG: Record<
  PropertyStatus,
  {
    label: string
    dropdownLabel: string
    color: 'success' | 'caution' | 'error' | 'info' | 'neutral'
  }
> = {
  draft: { label: 'Draft', dropdownLabel: 'Draft', color: 'neutral' },
  available: { label: 'Actively reviewing offers', dropdownLabel: 'Active', color: 'success' },
  under_contract: { label: 'Under contract', dropdownLabel: 'Under Contract', color: 'caution' },
  sold: { label: 'Sold', dropdownLabel: 'Sold', color: 'info' },
  removed: { label: 'Removed', dropdownLabel: 'Removed', color: 'error' },
}

/** Check if property status allows offers/questions */
export function canInteractWithProperty(status: PropertyStatus): boolean {
  return status !== 'sold' && status !== 'removed'
}
